import { useState } from 'react';
import { Grid, Menu } from '@material-ui/core';
import { map, truncate } from 'lodash'
import { useCompany, useCompanyFunctions } from 'contexts/CompanyContext';
import { useTheme } from '@material-ui/core/styles';
import DefaultMenuItem from 'components/DefaultMenuItem';
import listIcon from '_assets/dashboard/list-icon.svg';

function CompanyMenu() {
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState(null);
  const { companies, currentCompany } = useCompany()
  const { changeCurrentCompany } = useCompanyFunctions()

  function handleClickListItem(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleMenuItemClick(companyId) {
    changeCurrentCompany(companyId);
    setAnchorEl(null);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <>
      <Grid
        container
        item xs={8}
        justifyContent="center"
        style={{
          borderBottom: `1px solid ${theme.palette.text.title}`,
          color: theme.palette.text.title,
          cursor: "pointer",
          margin: "3vh 0 0 1vw",
          height: "1.5rem",
        }}
        onClick={handleClickListItem}>
        <Grid item xs={10} style={{ wordWrap: "normal", overflow: "hidden", textAlign: 'center', textOverflow: "hidden", whiteSpace: "nowrap" }}>
          {truncate(currentCompany.social_name || 'Entreprise', { length: 15 })}
        </Grid>
        <Grid item>
          <img alt="arrowBottom" src={listIcon} />
        </Grid>
      </Grid>
      <Menu
        id="company-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {map(companies, ({id, social_name}) => (
          <DefaultMenuItem
            key={id}
            selected={currentCompany.id === id}
            style={{ borderRadius: 0 }}
            onClick={() => handleMenuItemClick(id)}
          >
            {social_name}
          </DefaultMenuItem>
        ))}
      </Menu>
    </>
  )
}

export default CompanyMenu;
